import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/_services/user/user.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service'

@Component({
  selector: 'app-onboarding-nda',
  templateUrl: './onboarding-nda.component.html',
  styleUrls: ['./onboarding-nda.component.scss']
})
export class OnboardingNdaComponent implements OnInit {
  tenantId: string;
  usersForm;
  userCreationForm;
  userDropdownList = [];
  getUserName: any;
  isNDAAdmin: boolean;
  userDetails: any;
  requester: any;
  userCreationId: any;
  userFullName: any;

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
  ) {
    this.usersForm = this.formBuilder.group({
      id: new FormControl(''),
      userId: new FormControl('', [ Validators.required ] ),
      password: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      displayName: new FormControl('', Validators.required),
      department: new FormControl('', Validators.required),
      phoneNo: new FormControl(''),
      location: new FormControl(''),
      joinDate: new FormControl(''),
      permanentOrContractor: new FormControl(''),
      alternateEmailId: new FormControl('', Validators.required),
      supervisorId: new FormControl(''),
      supervisonName: new FormControl('', Validators.required),
      currentDesignation: new FormControl(''),
      careerStartDate: new FormControl(''),
      middleName: new FormControl(''),
      managerId: new FormControl(''),
      managerName: new FormControl(''),
      addedToBioMetrics: new FormControl(''),
      totalExperience: new FormControl(''),
      currentExperience: new FormControl(''),
      localId: new FormControl(''),
      birthDate: new FormControl(''),
    });
    this.userCreationForm = this.formBuilder.group({
      id: new FormControl(''),
      requesterId: new FormControl({value:'' , disabled: true}),
      requesterName: new FormControl({value:'' , disabled: true}),
      requestedDate: new FormControl({value:'' , disabled: true}),
      status: new FormControl({value:''}),
      userId: new FormControl({value:'' , disabled: true}),
      firstName: new FormControl({value:'' , disabled: true}),
      middleName: new FormControl({value:'' , disabled: true}),
      lastName: new FormControl({value:'' , disabled: true}),
      emailId: new FormControl({value:'' , disabled: true}),
      remarks: new FormControl({value:'' , disabled: true}),
      addedToBioMetrics: new FormControl(''),
      licenseType: new FormControl(''),
      licenseRequired: new FormControl(''),
      licenseAllocation: new FormControl(''),
      systemRequiredBoolean: new FormControl({value:'' , disabled: true}),
      systemRequired: new FormControl({value:'' , disabled: true}),
      ndaSignedDate: new FormControl({value:'' , disabled: true}),
      biometric: new FormControl(''),
      ismsTraining: new FormControl({value:'' , disabled: true}),
      ismsAgreement: new FormControl({value:'' , disabled: true}),
      joinDate: new FormControl(''),
      emailIdRequired: new FormControl({value:''}),
      ndaSignedBoolean: new FormControl({value:''}),
      domainUserId: new FormControl({value:''})
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));

    this.isNDAAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleNDATeam') ;
    
    this.userCreationForm.patchValue(this.userCreationForm.value);
    this.userCreationId = this.route.snapshot.paramMap.get('id');
    if (this.userCreationId) {
      this.getUserCreationById(this.userCreationId);
    }
  }

  getUserCreationById(id){
    this.userService.getUserCreationById(id).subscribe((response) => {
      console.log("response",response);
      if (response) {
        this.userCreationForm.patchValue({
          requesterId: response.requesterId + " . " + response.requesterName,
          requestedDate: response.requestedDate,
          userId: response.userId + " . " + response.firstName + " " + response.lastName,
          status: response.status,
          remarks: response.remarks,
          addedToBioMetrics: response.addedToBioMetrics,
          ndaSignedBoolean: response.ndaSignedBoolean,
          ndaSignedDate: response.ndaSignedDate,
        })
      }

      let userId = response.userId;
      this.userService.getUser(userId).subscribe((response) => {
        this.userFullName = response.firstName + " "+ response.middleName + " " + response.lastName;
        this.usersForm.patchValue({
          userId: response.userId,
          localId: response.localId,
          password: response.password,
          firstName: response.firstName,
          middleName: response.middleName,
          lastName: response.lastName,
          displayName: response.displayName,
          department: response.department,
          alternateEmailId: response.alternateEmailId,
          phoneNo: response.phoneNo,
          location: response.location,
          joinDate: response.joinDate,
          permanentOrContractor: response.permanentOrContractor,
          supervisonName: response.supervisorId + ' . ' + response.supervisonName,
          currentDesignation: response.currentDesignation,
          archived: true,
          managerName: response.managerName,
          birthDate: response.birthDate,
        });
        this.userCreationForm.value.joinDate = response.joinDate;
        this.userCreationForm.value.emailId = response.emailId;
        this.userCreationForm.patchValue(this.userCreationForm.value);
      })
    })
  }

  updateUserCreation(){
    let userId = this.userCreationForm.get('userId').value.split(' . ')[0];
    let user = {
      id: parseInt(userId),
      userId: this.usersForm.get('userId').value,
      localId: this.usersForm.get('localId').value,
      password: this.usersForm.get('password').value,
      firstName: this.usersForm.get('firstName').value,
      middleName: this.usersForm.get('middleName').value,
      lastName: this.usersForm.get('lastName').value,
      displayName: this.usersForm.get('displayName').value,
      department: this.usersForm.get('department').value,
      emailId: this.userCreationForm.get('emailId').value,
      alternateEmailId: this.usersForm.get('alternateEmailId').value,
      phoneNo: this.usersForm.get('phoneNo').value,
      location: this.usersForm.get('location').value,
      joinDate: this.usersForm.get('joinDate').value,
      permanentOrContractor: this.usersForm.get('permanentOrContractor').value,
      supervisorId: parseInt(this.usersForm.get('supervisonName').value.split(' . ')[0]),
      supervisonName: this.usersForm.get('supervisonName').value.split(' . ')[1],
      currentDesignation: this.usersForm.get('currentDesignation').value,
      archived: true,
      managerName: this.usersForm.get('managerName').value,
      birthDate: this.usersForm.get('birthDate').value,
    }
    this.userService.updateUser(userId, user).subscribe((response)=>{
      let userCreationData = {
        id: parseInt(this.userCreationId),
        requesterId: this.userCreationForm.get('requesterId').value.split(' . ')[0],
        requesterName: this.userCreationForm.get('requesterId').value.split(' . ')[1],
        requestedDate: this.userCreationForm.get('requestedDate').value,
        userId: this.userCreationForm.get('userId').value.split(' . ')[0],
        firstName: this.usersForm.get('firstName').value,
        lastName: this.usersForm.get('lastName').value,
        emailId: this.userCreationForm.get('emailId').value,
        status: this.userCreationForm.get('status').value,
        remarks: this.userCreationForm.get('remarks').value,
        addedToBioMetrics: this.userCreationForm.get('addedToBioMetrics').value,
      }
      if (response) {
        this.userService.updateUserCreation(this.userCreationId, userCreationData).subscribe((response) => {
          this.backToOnboarding();
        })
      }
    })
  }

  openItonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-it', {id: this.userCreationId}]);
  }

  openHrmonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-form', {id: this.userCreationId}]);
  }

  openndaonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-nda', {id: this.userCreationId}]);
  }

  backToOnboarding(){
    this.router.navigate([ this.tenantId + '/dashboard/itm/onboarding' ]);
  }
}
